module.exports = __webpack_public_path__ + "static/media/blog5.ea652077.jpg";